import { v4 as uuid } from "uuid"

/**
 * Function to generate a unique id for HTML tags
 */
export function generateID() {
  return `hig-${uuid()}`
}
